import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'
import List from '../views/List.vue'
import Detail from '../views/Detail.vue'
import Setting from '../views/Setting.vue'
import FailedVideos from '../views/FailedVideos.vue'
import { Auth0 } from '@/auth'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: Auth0.routeGuard,
  },
  {
    path: '/list',
    name: 'List',
    component: List,
    beforeEnter: Auth0.routeGuard,
  },
  {
    path: '/failed-videos',
    name: 'FailedVideos',
    component: FailedVideos,
    beforeEnter: Auth0.routeGuard,
  },
  {
    path: '/:id',
    name: 'Detail',
    component: Detail,
    beforeEnter: Auth0.routeGuard,
  },
  {
    path: '/setting',
    name: 'Setting',
    component: Setting,
    beforeEnter: Auth0.routeGuard,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    beforeEnter: Auth0.routeGuard,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
